<template>
  <div class="modal animated is-active">
    <div class="modal-background"></div>
    <div class="modal-card is-large">
      <header class="modal-card-head">
        <p class="modal-card-title">Account Sub # {{account_sub.id}} - {{account_sub.total}} - {{account_sub.currency}} </p>
      </header>
      <section class="modal-card-body">
        <div class="notification is-danger" v-if="error !== ''">{{ error }}</div>
        <div class="control is-vertical">
          <template>
            <div class="control is-grouped">
              <p class="control is-expanded">
                <label class="label">Amount</label>
                <input class="input" name="amount" id="amount" type="text" placeholder="" v-model="transfer.amount">
              </p>
              <p class="control is-expanded">
                <label class="label">Currency</label>
                <select class="select is-fullwidth" v-model="transfer.transfer_currency" name="currency" id="currency">
                  <option value="BRL" v-if="account_sub.currency != 'BRL'">BRL</option>
                  <option value="USD" v-if="account_sub.currency != 'USD'">USD</option>
                  <option value="EUR" v-if="account_sub.currency != 'EUR'">EUR</option>
                  <option value="AUD" v-if="account_sub.currency != 'AUD'">AUD</option>
                  <option value="CAD" v-if="account_sub.currency != 'CAD'">CAD</option>
                  <option value="MXN" v-if="account_sub.currency != 'MXN'">MXN</option>
                  <option value="GBP" v-if="account_sub.currency != 'GBP'">GBP</option>
                  <option value="ARS" v-if="account_sub.currency != 'ARS'">ARS</option>
                  <option value="ZAR" v-if="account_sub.currency != 'ZAR'">ZAR</option>
                  <option value="THB" v-if="account_sub.currency != 'THB'">THB</option>
                </select>
              </p>
              <p class="control is-expanded">
                <label class="label">Exchange</label>
                <input class="input" name="exchange" id="exchange" type="text" placeholder="" v-model="transfer.exchange" @change="setTotal()">
              </p>
              <p class="control is-expanded">
                <label class="label">Total</label>
                <input class="input is-disabled" name="total" id="total" type="text" placeholder="" v-model="transfer.total">
              </p>
            </div>
          </template>
        </div>
      </section>
      <footer class="modal-card-foot">
        <div class="control is-grouped is-pulled-right">
          <p class="control is-pulled-right">
            <a class="button is-primary" @click="close(true)">Cancel</a>
          </p>
          <p class="control">
            <a :class="{'button': true, 'is-success': true, 'is-disabled': inProgress, 'is-loading': inProgress}" @click="transferCredit()">Transfer</a>
          </p>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      context: {
        type: Object
      },
      account_sub: {
        type: Object,
        required: true
      },
      callback: {
        type: String
      }
    },
    data () {
      return {
        transfer: {
          transfer_currency: '',
          currency: '',
          amount: 0,
          exchange: 0,
          total: 0,
          account_sub: null
        },
        inProgress: false,
        error: ''
      }
    },
    mounted () {
      this.$nextTick(() => {
        document.body.appendChild(this.$el)
        this.transfer.account_sub = this.account_sub
      })
    },
    methods: {
      setTotal () {
        this.transfer.total = parseFloat(this.transfer.amount * this.transfer.exchange).toFixed(2)
      },
      close (closeOnly, result) {
        if (!closeOnly) {
          this.context[this.callback](result)
        }
        this.$el.remove()
      },
      transferCredit () {
        this.inProgress = true
        this.transfer.currency = this.account_sub.currency
        if (parseFloat(this.transfer.amount) <= 0) {
          this.error = 'Please set amount!'
          this.inProgress = false
          return false
        }
        if (parseFloat(this.transfer.amount) > parseFloat(this.account_sub.total)) {
          this.error = 'There are not enough funds for the transfer!'
          this.inProgress = false
          return false
        }
        if ((this.transfer.currency === '')) {
          this.error = 'Please set exchange!'
          this.inProgress = false
          return false
        }
        if (this.transfer.exchange === 0) {
          this.error = 'Please set exchange!'
          this.inProgress = false
          return false
        }
        if (window.confirm('Are you sure you want to transfer credits?')) {
          this.error = ''
          this.context.$http.post(this.context.$store.state.config.apiURL + '/account/transfer', this.transfer).then((response) => {
            if (response.body.hasOwnProperty('error')) {
              this.error = response.body.message
            } else {
              this.close(false, 'ok')
            }
            this.inProgress = false
          }, (response) => {
            this.inProgress = false
            this.error = response.body
          })
        } else {
          this.inProgress = false
        }
      }
    },
    components: {
    },
    computed: {
      enterClass () {
        return `${this.transition}In`
      },
      leaveClass () {
        return `${this.transition}Out`
      }
    }
  }
</script>
<style lang="scss">

</style>



// WEBPACK FOOTER //
// AccountSubTransferCredit.vue?e5affd6c